import { checkHttpStatus, parseJSON, expiredToken, errorResponse, okResponse, successResponse } from '@utils/response';
import { toDecimal, toISOLocal, isNullOrEmpty } from '@utils';
import { Token, UserCode } from '@utils/users';
import { GetLanguage } from '@utils/language';

export function loadForm(origin, mode, punchEnCrypt, epcdCrypt) {
    return fetch('punchApproval/loadForm', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            language: GetLanguage(),
            origin,
            mode,
            punchEnCrypt,
            epcdCrypt,
            token: Token(),
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            return successResponse(response);
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function refreshFormSrv(origin, mode, actionType, model, payCodeIndex, isHolidayPaycodeDefaults, currentEmploymentStatus) {
    const comboModel = {
        userCode: UserCode(),
        language: GetLanguage(),
        origin,
        mode,
        actionType,        
        epcdCrypt: model.epcdCrypt,
        employeeCode: model.employeeCode,
        punchEnCrypt: model.punchEnCrypt,
        startDate: model.realStartTime,
        endDate: model.realEndTime,
        abcProjectCode: model.abcProjectCode,
        abcActivityCode: !isNullOrEmpty(model.abcActivityCode) ? parseInt(model.abcActivityCode) : null,
        payProjectCode: model.payProjectCode,
        payActivityCode: model.payActivityCode,
        departmentCode: model.departmentCode,
        jobTitle: model.jobTitle,
        workRangeId: !isNullOrEmpty(model.workRangeId) ? parseInt(model.workRangeId) : 0,
        taskCode: model.taskCode,
        workOrder: model.workOrder,
        otherClassification: model.otherClassification,
        requisitionCode: model.requisitionCode,
        payCode1: model.payCode1,
        payCode2: model.payCode2,
        payCode3: model.payCode3,
        payCode4: model.payCode4,
        payCode5: model.payCode5,
        payCode6: model.payCode6,
        bloc: model.bloc,
        isLimitedEdition: model.isLimitedEdition,
        payCodeIndex,
        isHolidayPaycodeDefaults: isHolidayPaycodeDefaults ?? false,
        currentEmploymentStatus: currentEmploymentStatus ?? null
    };

    return fetch('punchApproval/refreshCombos', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...comboModel,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            return successResponse(response);
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function savePunch(config, model) {

    model.duration1 = toDecimal(model.duration1);
    model.duration2 = toDecimal(model.duration2);
    model.duration3 = toDecimal(model.duration3);
    model.duration4 = toDecimal(model.duration4);
    model.duration5 = toDecimal(model.duration5);
    model.duration6 = toDecimal(model.duration6);
    model.paidMileage = toDecimal(model.paidMileage);
    model.chargedMileage = toDecimal(model.chargedMileage);
    model.realStartTime = toISOLocal(model.realStartTime);
    model.realEndTime = toISOLocal(model.realEndTime);
    model.punchStart = toISOLocal(model.punchStart);
    model.punchEnd = toISOLocal(model.punchEnd);
    
    const body = JSON.stringify({
        userCode: UserCode(),
        language: GetLanguage(),
        ...model,        
        commentForApprovOnPunch: config.commentForApprovOnPunch,
        isJobTitleEntry: config.isJobTitleEntry,
        isProjectEntry: config.isProjectEntry,
        isPayProjectLoadedFromWorkorder: config.isPayProjectLoadedFromWorkorder,
        isActivityEntry: config.isActivityEntry,
        isUseAbc: config.isUseAbc,
        isUseWorkorderInPunch: config.isUseWorkorderInPunch,
        isTaskEntry: config.isTaskEntry,
        isUseOtherClassification: config.isUseOtherClassification,
        isUseRequisitionCodeOnPunch: config.isUseRequisitionCodeOnPunch,
        token: Token()
    });

    return fetch('punchApproval/savePunch', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            return successResponse(response);
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function deletePunch(origin, mode, punchEnCrypt, epcdCrypt) {
    return fetch('punchApproval/delete', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            language: GetLanguage(),
            origin,
            mode,
            punchEnCrypt,
            epcdCrypt,
            token: Token(),
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            return successResponse(response);
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getPunchApprovalList(startDate, endDate) {
    return fetch('punchApproval/getPunchApprovalList', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            language: GetLanguage(),
            startDate: startDate,
            endDate: endDate,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return response.result;
                }

                return okResponse({ result: JSON.parse(response.result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function punchApprove(punchIds, isApprove) {
    return fetch('punchApproval/punchApprove', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            punchIdString: punchIds,
            isApprove: isApprove,
            language: GetLanguage(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return response.result;
                }

                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}
